import { FeatureData } from '../../components/ui/feature-section-with-hoover-effect';
import {
  IconAffiliate,
  IconBinaryTree2,
  IconUserShield,
  IconBrandAzure,
} from '@tabler/icons-react';

const formationEntraFeatures: FeatureData[] = [
  {
    title: '',
    description: '',
    icon: <IconAffiliate size={24} />,
    key: "formationEntra.features.1",
  },
  {
    title: '',
    description: '',
    icon: <IconBinaryTree2 size={24} />,
    key: 'formationEntra.features.2'
  },
  {
    title: '',
    description: '',
    icon: <IconUserShield size={24} />,
    key: 'formationEntra.features.3'
  },
  {
    title: '',
    description: '',
    icon: <IconBrandAzure size={24} />,
    key: 'formationEntra.features.4'
  },
];

export default formationEntraFeatures; 